import script from "./GraphComponent.vue?vue&type=script&setup=true&lang=ts"
export * from "./GraphComponent.vue?vue&type=script&setup=true&lang=ts"

import "./GraphComponent.vue?vue&type=style&index=0&id=79ae2280&lang=scss"

const __exports__ = script;

export default __exports__